import { action, makeAutoObservable } from 'mobx';

import { CustomGradeCode } from '@/customGrading/constants/customGradeCodes';
import GradeAttribute from '@/customGrading/entity/GradeAttribute';
import GradeDictEntry from '@/customGrading/entity/GradeDictEntry';

import { customGradeAttributeStore } from '../stores/CustomGradeAttributeStore';

export interface GradeResultModel {
  value?: StringOrNumber;
  customGradeCode: CustomGradeCode;
}

export default class GradeResult {
  rawValue?: StringOrNumber;

  customGradeCode: CustomGradeCode;

  gradeAttribute!: GradeAttribute;

  constructor({ value, customGradeCode }: GradeResultModel) {
    makeAutoObservable(this);

    this.rawValue = value;
    this.customGradeCode = customGradeCode;

    const gradeAttribute = customGradeAttributeStore.attributes[this.customGradeCode];

    if (!gradeAttribute) {
      customGradeAttributeStore.fetchItem(this.customGradeCode)?.then(
        action((gradeAttribute: GradeAttribute) => {
          this.gradeAttribute = gradeAttribute;

          this.setDefaultRawValue();
        }),
      );
    } else {
      this.gradeAttribute = gradeAttribute;

      this.setDefaultRawValue();
    }
  }

  get title() {
    return this.value?.title;
  }

  get value() {
    if (!this.gradeAttribute || !this.gradeAttribute.dict) {
      return null;
    }

    return this.gradeAttribute.dict.find((d: GradeDictEntry) => d.id === this.rawValue);
  }

  setDefaultRawValue = () => {
    if (!this.rawValue) {
      this.rawValue = this.gradeAttribute.dict[Math.ceil(this.gradeAttribute.dict.length / 2)].id;
    }
  };
}
